import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import BankCard from '../../BankCard/BankCard';
import SuccessCheckBadge from '../../SuccessCheckBadge/SuccessCheckBadge';
import { getCard } from '../../../assets/services/cards';
import CardPage from '../CardPage/CardPage';
import ScreenHeader from '../../ScreenHeader/ScreenHeader';
import BottomActionButton from '../../shared/BottomActionButton/BottomActionButton';
import './CardCreated.css';

function CardCreated() {
  const navigate = useNavigate();
  const { card: cardCopy, common } = useContext(TranslationContext);
  const card = getCard();

  useEffect(() => {
    if (!card) {
      navigate('/cards/new', { replace: true });
    }
  }, [card, navigate]);

  if (!card) {
    return null;
  }

  return (
    <CardPage>
      <ScreenHeader title={cardCopy.newCard} onBack={() => navigate('/cards/new')} />

      <div className="card-page__body card-created__body">
        <SuccessCheckBadge className="card-created__badge" />

        <h1 className="card-created__title">{cardCopy.cardCreated}</h1>
        <p className="card-created__subtitle">{cardCopy.cardCreatedText}</p>

        <BankCard
          cardStyle={card.style}
          cardType={card.type}
          showCardType
          size="preview"
          lastFour={card.lastFour}
          className="card-created__preview"
        />
      </div>

      <BottomActionButton
        className="card-page__cta"
        onClick={() => navigate('/home', { replace: true })}
      >
        {common.done}
      </BottomActionButton>
    </CardPage>
  );
}

export default CardCreated;
